import { motion } from "framer-motion";
import { useQuery } from "@tanstack/react-query";
import { MapPin, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import SectionHeading from "@/components/SectionHeading";
import { EVENTS } from "@/constants/site";
import { useSectionContent } from "@/hooks/useContent";

export default function Events() {
  const { data: dbEvents } = useQuery({
    queryKey: ["events"],
    queryFn: async () => (await api.get("/events")).data,
  });
  const c = useSectionContent("events_section");

  const events =
    dbEvents && dbEvents.length > 0
      ? dbEvents
      : EVENTS.map((e, i) => ({ ...e, id: `static-${i}`, year: "2026" }));

  return (
    <section id="eventi" data-testid="events-section" className="py-24 sm:py-32 px-5 sm:px-8">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          overline={c.overline}
          title={c.title}
          description={c.description}
          testid="events-heading"
        />

        <div className="mt-14 space-y-4">
          {events.map((event, i) => (
            <motion.article
              key={event.id}
              data-testid={`event-card-${i}`}
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              className="leather-card group flex flex-col sm:flex-row sm:items-center gap-6 p-6 sm:p-8"
            >
              <div className="flex sm:flex-col items-center sm:items-start gap-3 sm:gap-1 sm:w-28 shrink-0 border-b sm:border-b-0 sm:border-r border-[#C5A059]/20 pb-4 sm:pb-0 sm:pr-8">
                <span className="font-display text-4xl sm:text-5xl font-black text-gold-gradient leading-none">
                  {event.day}
                </span>
                <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#78746D]">
                  {event.month} {event.year}
                </span>
              </div>
              <div className="flex-1">
                <h3 className="font-display text-xl sm:text-2xl font-semibold text-[#F4EBE1] group-hover:text-[#C5A059] transition-colors duration-300">
                  {event.title}
                </h3>
                <p className="mt-2 flex items-center gap-2 text-sm text-[#C0B9B0]">
                  <MapPin className="w-4 h-4 text-[#9E1B1B]" />
                  {event.location}
                </p>
              </div>
              <ArrowRight className="hidden sm:block w-5 h-5 text-[#78746D] group-hover:text-[#C5A059] group-hover:translate-x-1 transition-all duration-300" />
            </motion.article>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-8 font-mono text-xs uppercase tracking-[0.25em] text-[#78746D] text-center"
        >
          Le uscite del Neapolis Free Chapter sono riservate ai soci.
        </motion.p>
      </div>
    </section>
  );
}
